// extracted by mini-css-extract-plugin
module.exports = {"title":"List_title__IWhTh","table":"List_table__LUC0p"};